import { MyButton } from "../../components/button";
import { Title } from "../../components/title";
import { Subtitle } from "../../components/subtitle";
import { Link, useNavigate } from "react-router-dom";
import s from "./home.module.scss";
import { useEffect } from "react";
import { gsap } from "gsap";
import { useTranslation } from "react-i18next";

export const Home = ({ reference }) => {
  const nav = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    let ctx = gsap.context(() => {
      gsap.from(`.${s.home}`, {
        duration: 1,
        y: 100,
        opacity: 0,
      });
    }, reference);
    return () => ctx.revert();
  }, [reference]);
  return (
    <div className={s.home}>
      <div className={s.title}>
        <Title size={45} span={t("name")}>
          {t("surname")}
        </Title>
      </div>
      <Subtitle skills={[t("animation_web"), t("animation_game")]} size={25}>
        {t("animation_Iam")}
      </Subtitle>
      <MyButton onClick={() => nav("/contact")}>
        <Link to="/contact">{t("home_getInTouch")}</Link>
      </MyButton>
    </div>
  );
};
